import { Tab as MuiTab, TabProps as MuiTabProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Tab = styled(MuiTab)({
  minWidth: '130px',
});
export type TabProps = MuiTabProps;
